import type { Module } from '@/types/modules';

/**
 * Pure helper extracted from ChatBox: find all modules matching an object type.
 * Filters the conversation's available modules by their resolved `objectType`
 * and returns the id/label of each match.
 */
export function findModulesByObjectType(
  availableModules: Module[],
  objectType: string,
): Array<{ id: string; label: string }> {
  if (availableModules.length === 0) return [];
  return availableModules
    .filter(m => m.objectType === objectType)
    .map(m => ({ id: m.id, label: m.label }));
}
